import axios from 'axios';
import { API_CONFIG } from '../config/api';

const base = API_CONFIG.BASE_URL;

export const notificationService = {
  list: () =>
    axios.get(`${base}/api/notifications`, { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } })
      .then(r => r.data),

  markRead: (id) =>
    axios.post(`${base}/api/notifications/read/${id}`, {}, { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } })
      .then(r => r.data),

  markAllRead: () =>
    axios.post(`${base}/api/notifications/read-all`, {}, { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } })
      .then(r => r.data),

  deleteAll: () =>
    axios.delete(`${base}/api/notifications`, { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } })
      .then(r => r.data),
};
